import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import MyTable from "../components/MyTable";
import { useDispatch, useSelector } from "react-redux";
import { fetchArticleMovements } from "../store/stockSlice";
import { formatDate, formatQuantity } from "../services/utils";
import {fetchSpecificSales} from "../store/salesSlice";

import useSaleDocument from "../services/useSaleDocument";

const ArticleMovements = () => {
  const { article: routeArticle } = useParams();
  const { selectedShop } = useSelector((state) => state.shop);
  const { articleMovements, articlePagination } = useSelector(
    (state) => state.stock
  );
  
  
  const [filter, setFilter] = useState({
    page: 0,
    limit: 5,
    article: routeArticle || "", // Default to route parameter if provided
    shop:selectedShop?._id || "",
    owner: "",
    startDate: "",
    endDate: "",
  });

  const { openSaleDocument, SaleDialog } = useSaleDocument();

  
  const dispatch = useDispatch();

  // Fetch data whenever the filter changes
  useEffect(() => {
    dispatch(
      fetchArticleMovements({
        page: filter.page + 1,
        limit: filter.limit,
        article: filter.article,
        shop: filter.shop,
        owner: filter.owner,
        startDate: filter.startDate,
        endDate: filter.endDate,
        
      })
    );
  }, [filter, dispatch]);

  // Update article filter when routeArticle changes
  useEffect(() => {
    if (routeArticle !== filter.article) {
      setFilter((prevFilter) => ({
        ...prevFilter,
        article: routeArticle,
      }));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [routeArticle,]);

  // Handle page, rows per page, and other filter changes
  const handlePageChange = (newPage, newRowsPerPage) => {
    setFilter((prevFilter) => ({
      ...prevFilter,
      page: newPage,
      limit: newRowsPerPage,
    }));
  };





  const actions = [
    {
      label: "Display",
      type: "display",
      permission: true,
      callback: async (item) => {
      dispatch(fetchSpecificSales({_id:item._id}))
        openSaleDocument(item.mouvementType,null,false)
      },
    },
  ];
  // Table headers (adjust based on your data structure)
  const headers = [
    {
      key: "name",
      label: "Name",
      render: (row) => row.article?.name || "N/A", // Handle cases where article or name may be undefined
    },
    {
      key: "quantity",
      label: "Quantity",
      render: (row) =>
        formatQuantity({
          isVenteDetail: row.article?.isAlowSecondaryUnit,
          quantity: row.quantity,
          nombreDePiece: row.article?.unitsQte,
          primaryUnit: row.article?.primaryUnits,
          secondaryUnit: row.article?.secondaryUnits,
        }),
    },
    { key: "cumulativeStock",
       label: "Stock",
       render: (row) =>
        formatQuantity({
          isVenteDetail: row.article?.isAlowSecondaryUnit,
          quantity: row.cumulativeStock,
          nombreDePiece: row.article?.unitsQte,
          primaryUnit: row.article?.primaryUnits,
          secondaryUnit: row.article?.secondaryUnits,
        }),
       },
    { key: "mouvementType", 
      label: "Movement Type",
      render: (row) =>row.mouvementType.name
     },
     { key: "shop", 
      label: "Shop",
      render: (row) =>row.shop.name
     },
    { key: "saleNumero", label: "Sale Number" },
    { key: "date",
          label: "Date",
          render:(row)=> formatDate(row.date)
          },
    
  ];
  const printOptions= {
    title: `Mouvement stock`,
    paperHeader: {
      
    },
    landscape: true
  }
  

  return (
    <div>
      <h2>Article Movements</h2>

      <MyTable
        headers={headers}
        data={articleMovements} // Pass filtered data
        totalRows={articlePagination?.total} // Pass total number of rows for pagination
        onPageChange={handlePageChange} // Handle page and rowsPerPage changes
        rowsPerPage={filter.limit} // Pass current rows per page from filter state
        page={filter.page} // Pass current page index from filter state
        actions={actions}
        printOptions={printOptions}
      />
        {SaleDialog}
    </div>
  );
};

export default ArticleMovements;
